window.mcb = window.mcb || {};
window.mcb.forms = window.mcb.forms || {};
window.mcb.forms.submit = window.mcb.forms.submit || {};
window.mcb.forms.debug = window.mcb.utilities.debug.isDebuggingArea('forms');
window.mcb.forms.instances = [];

window.mcb.forms.constants = {};
window.mcb.forms.constants.formClass = 'mcb-webform';
window.mcb.forms.constants.classRoot = 'mcb-webform--';
window.mcb.forms.constants.countdown = 'mcb-webform--countdown';
window.mcb.forms.constants.valueCollectingIsActive = 'mcb-webform--collecting-values';
window.mcb.forms.constants.authenticationIsActive = 'mcb-webform--authenticating';

window.mcb.forms.constants.notifications = {};
window.mcb.forms.constants.notifications.baseSelector = '.mcb-webform--notification';
window.mcb.forms.constants.notifications.canvas = 'mcb-webform--notification--canvas';
window.mcb.forms.constants.notifications.canvasBefore = 'mcb-webform--notification--canvas--before';
window.mcb.forms.constants.notifications.canvasAfter = 'mcb-webform--notification--canvas--after';
window.mcb.forms.constants.notifications.notification = 'mcb-webform--notification--message';

window.mcb.forms.constants.hidden = 'mcb-webform--hidden';
window.mcb.forms.constants.removing = 'mcb-webform--removing';
window.mcb.forms.constants.formButtonSelector = '.' + window.mcb.forms.constants.classRoot + 'footer button';
window.mcb.forms.constants.formButtonClass = window.mcb.forms.constants.classRoot + 'control--button';
window.mcb.forms.constants.formHasAuthentication = window.mcb.forms.constants.classRoot + 'has-authentication';
window.mcb.forms.constants.formHasNuget = '.' + window.mcb.forms.constants.classRoot + 'has-nuget';

window.mcb.forms.constants.fields = {};
window.mcb.forms.constants.fields.baseSelector = '.mcb-webform--field';
window.mcb.forms.constants.fields.checksClass = 'mcb-webform--field--checks';
window.mcb.forms.constants.fields.classBase = 'mcb-webform--field';
window.mcb.forms.constants.fields.classBaseDashed = 'mcb-webform--field--';
window.mcb.forms.constants.fields.collectionClass = 'mcb-webform--field--collection';
window.mcb.forms.constants.fields.collectionHorizontalClass = 'mcb-webform--field--collection--horizontal';
window.mcb.forms.constants.fields.collectionItemClass = 'mcb-webform--field--collection--item';
window.mcb.forms.constants.fields.controlClass = 'mcb-webform--field--control';
window.mcb.forms.constants.fields.dateClass = 'mcb-webform--field--date';
window.mcb.forms.constants.fields.descriptionClass = 'mcb-webform--field--description';
window.mcb.forms.constants.fields.dropdownClass = 'mcb-webform--field--dropdown';
window.mcb.forms.constants.fields.errorMessageClass = 'mcb-webform--field--message--error';
window.mcb.forms.constants.fields.filesClass = 'mcb-webform--field--files';
window.mcb.forms.constants.fields.fileClass = 'mcb-webform--field--file';
window.mcb.forms.constants.fields.filelist = 'mcb-webform--field--filelist';
window.mcb.forms.constants.fields.filewrapper = 'mcb-webform--field--file--wrapper';
window.mcb.forms.constants.fields.filerow = 'mcb-webform--field--file--row';
window.mcb.forms.constants.fields.addedselector = 'mcb-webform--field--added-selector';
window.mcb.forms.constants.fields.filelistbutton = 'mcb-webform--field--filelist--button';
window.mcb.forms.constants.fields.filelistselector = 'mcb-webform--field--filelist--selector';
window.mcb.forms.constants.fields.singlefileClass = 'mcb-webform--field--singlefile';
window.mcb.forms.constants.fields.removablefileClass = 'mcb-webform--field--removablefile';
window.mcb.forms.constants.fields.headingClass = 'mcb-webform--field--heading';
window.mcb.forms.constants.fields.labelClass = 'mcb-webform--field--label';
window.mcb.forms.constants.fields.accordionSelectionClass = 'mcb-webform--field--accordion-item';
window.mcb.forms.constants.fields.numberClass = 'mcb-webform--field--number';
window.mcb.forms.constants.fields.paragraphClass = 'mcb-webform--field--paragraph';
window.mcb.forms.constants.fields.previewClass = 'mcb-webform--field--preview';
window.mcb.forms.constants.fields.requiredClass = 'mcb-webform--field--required';
window.mcb.forms.constants.fields.requiredMark = '*';
window.mcb.forms.constants.fields.uiInput = 'mcb-webform--field--input';
window.mcb.forms.constants.fields.requiredMarkClass = 'mcb-webform--field--required--mark';
window.mcb.forms.constants.fields.selectWrapperClass = 'mcb-webform--field--select--wrapper';
window.mcb.forms.constants.fields.selectClass = 'mcb-webform--field--select';
window.mcb.forms.constants.fields.typeBaseClass = 'mcb-webform--field--type--';
window.mcb.forms.constants.fields.typeAlphaNumericalClass = window.mcb.forms.constants.fields.typeBaseClass + 'alpha';
window.mcb.forms.constants.fields.typeCvrClass = window.mcb.forms.constants.fields.typeBaseClass + 'cvr';
window.mcb.forms.constants.fields.typeOrgNoClass = window.mcb.forms.constants.fields.typeBaseClass + 'orgno';
window.mcb.forms.constants.fields.typeEmailClass = window.mcb.forms.constants.fields.typeBaseClass + 'mail';
window.mcb.forms.constants.fields.typePhoneClass = window.mcb.forms.constants.fields.typeBaseClass + 'phone';
window.mcb.forms.constants.fields.typeRegNoClass = window.mcb.forms.constants.fields.typeBaseClass + 'regno';

window.mcb.forms.constants.blocks = {};
window.mcb.forms.constants.blocks.classBase = 'mcb-webform--block';
window.mcb.forms.constants.blocks.collectionClass = window.mcb.forms.constants.blocks.classBase + 's';

window.mcb.forms.constants.pages = {};
window.mcb.forms.constants.pages.classBase = 'mcb-webform--page';
window.mcb.forms.constants.pages.collectionClass = window.mcb.forms.constants.pages.classBase + 's';

window.mcb.forms.constants.conditionals = {};
window.mcb.forms.constants.conditionals.dependance = 'mcb-webform--conditional--';
window.mcb.forms.constants.conditionals.type = 'mcb-webform--conditional--type--';

window.mcb.forms.constants.validation = {};
window.mcb.forms.constants.validation.classBase = 'mcb-webform--validation';
window.mcb.forms.constants.validation.validationWrapper = 'mcb-webform--validated--control';
window.mcb.forms.constants.validation.validationTarget = 'mcb-webform--validate';
window.mcb.forms.constants.validation.validationIsActive = 'mcb-webform--validating';
window.mcb.forms.constants.validation.dataCollectionIsActive = 'mcb-webform--compiling';
window.mcb.forms.constants.validation.failureClass = 'mcb-webform--validation--failure';
window.mcb.forms.constants.validation.errorClass = 'mcb-webform--validation--error';
window.mcb.forms.constants.validation.warningClass = 'mcb-webform--validation--warning';
window.mcb.forms.constants.validation.errorClassUnknown = 'mcb-webform--validation--error--unknown';
window.mcb.forms.constants.validation.successClass = 'mcb-webform--validation--success';
window.mcb.forms.constants.validation.messageFailureClass = 'mcb-webform--validation--message--failed';
window.mcb.forms.constants.validation.messagePartialClass = 'mcb-webform--validation--message--partial';
window.mcb.forms.constants.validation.messageSuccessClass = 'mcb-webform--validation--message--success';
window.mcb.forms.constants.validation.messageClass = 'mcb-webform--validation--message';
window.mcb.forms.constants.validation.badResultsSelector = '.' + window.mcb.forms.constants.validation.messageFailureClass + ',.' + window.mcb.forms.constants.validation.errorClass;

window.mcb.forms.constants.messages = {};
window.mcb.forms.constants.messages.messageClass = 'mcb-form-block--warning-view-model';
window.mcb.forms.constants.messages.errorBlockingClass = 'error--blocking';
window.mcb.forms.constants.messages.progressClass = 'mcb-webform--progress';

window.mcb.forms.constants.forms = {};
//window.mcb.forms.constants.forms.
